import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { InvestorType } from "src/app/shared/enum/investor-type.enum";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-etapa-cadastro-email",
  templateUrl: "./etapa-cadastro-email.component.html",
  styleUrls: ["./etapa-cadastro-email.component.scss"],
})
export class EtapaCadastroEmailComponent {
  @Input() etapa: "dados" | "email" = "dados";
  @Input() typeForm: InvestorType;

  @Input() formInvestidorPF: FormGroup;
  @Input() formInvestidorPJ: FormGroup;
  @Input() formResponsavelEntidade: FormGroup;
  @Input() formToken: FormGroup;

  @Input() tableDdi: any[] = [];
  @Input() showPassword: boolean = false;
  @Input() maiorDeIdade: boolean = true;
  @Input() disableButton = "reenviar-codigo";
  @Input() nextDisabled: boolean = false;

  @Output() showPasswordChange = new EventEmitter<boolean>();
  @Output() proximo = new EventEmitter<void>();
  @Output() voltarToken = new EventEmitter<void>();
  @Output() continuarToken = new EventEmitter<void>();
  @Output() reenviarToken = new EventEmitter<void>();

  togglePassword() {
    this.showPasswordChange.emit(!this.showPassword);
  }

  termoPoliticaPrivacidade() {
    window.open(environment.privacyPolicy);
  }

  //Mask
  maskTelefone(telefone: number) {
    if (this.ddiPF.value == "+55") {
      if (telefone == 1) return "(00) 0000-0000";
      else return "(00) 0 0000-0000";
    } else return "";
  }

  // Get & Setter Global
  get token() {
    return this.formToken.get("token");
  }

  // Get & Setter PJ
  get nomePJ() {
    return this.formInvestidorPJ.get("nome");
  }

  get documentoIdentificadorPJ() {
    return this.formInvestidorPJ.get("documentoIdentificador");
  }

  get emailPJ() {
    return this.formInvestidorPJ.get("email");
  }

  get dataNascimentoPJ() {
    return this.formInvestidorPJ.get("dataNascimento");
  }

  get confirmaEmailPJ() {
    return this.formInvestidorPJ.get("confirmaEmail");
  }

  get senhaPJ() {
    return this.formInvestidorPJ.get("senha");
  }

  get confirmarSenhaPJ() {
    return this.formInvestidorPJ.get("confirmaSenha");
  }

  get termPJ() {
    return this.formInvestidorPJ.get("termoAceite");
  }

  // Get & Setter Entidade (Dados Responsável)
  get documentoIdentificadorResponsavelEntidade() {
    return this.formResponsavelEntidade.get("documentoIdentificador");
  }

  get nomeContatoResponsavelEntidade() {
    return this.formResponsavelEntidade.get("nomeContato");
  }

  get emailResponsavelEntidade() {
    return this.formResponsavelEntidade.get("email");
  }

  get confirmaEmailResponsavelEntidade() {
    return this.formResponsavelEntidade.get("confirmaEmail");
  }

  get senhaResponsavelEntidade() {
    return this.formResponsavelEntidade.get("senha");
  }

  get confirmarSenhaResponsavelEntidade() {
    return this.formResponsavelEntidade.get("confirmaSenha");
  }

  get termResponsavelEntidade() {
    return this.formResponsavelEntidade.get("termoAceite");
  }

  get dataNascimentoEntidade() {
    return this.formResponsavelEntidade.get("dataNascimento");
  }

  // Get & Setter PF
  get documentoIdentificadorPF() {
    return this.formInvestidorPF.get("documentoIdentificador");
  }

  get nomePF() {
    return this.formInvestidorPF.get("nome");
  }

  get emailPF() {
    return this.formInvestidorPF.get("email");
  }

  get confirmaEmailPF() {
    return this.formInvestidorPF.get("confirmaEmail");
  }

  get ddiPF() {
    return this.formInvestidorPF.get("codigoDdi");
  }

  get telefonePF() {
    return this.formInvestidorPF.get("telefone");
  }

  get celularPF() {
    return this.formInvestidorPF.get("celular");
  }

  get dataNascimentoPF() {
    return this.formInvestidorPF.get("dataNascimento");
  }

  get incapazPF() {
    return this.formInvestidorPF.get("incapaz");
  }

  get documentoResponsavelPF() {
    return this.formInvestidorPF.get("documentoResponsavel");
  }

  get nomeResponsavelPF() {
    return this.formInvestidorPF.get("nomeResponsavel");
  }

  get senhaPF() {
    return this.formInvestidorPF.get("senha");
  }

  get confirmarSenhaPF() {
    return this.formInvestidorPF.get("confirmaSenha");
  }

  get termPF() {
    return this.formInvestidorPF.get("termoAceite");
  }
}
